import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  const strengths = t("about.strengths", { returnObjects: true });

  return (
    <section id="about" className="about">
      <div className="wrap">
        <h2>{t("about.title")}</h2>
        <div className="about-grid">
          <div className="prose">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
          </div>
          <div className="strengths">
            <h3>{t("about.strengthTitle")}</h3>
            <p>{t("about.strengthLead")}</p>
            <ul>
              {strengths.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
